import React, { useState } from "react";
import { GrFormCheckmark } from "react-icons/gr";
import { RiAddBoxFill } from "react-icons/ri";
import { AiOutlineDelete, AiOutlineArrowRight } from "react-icons/ai";
import {
  Button,
  Timeline,
  Text,
  Card,
  Group,
  Avatar,
  Select,
  Chips,
  Chip,
  Paper,
  Divider,
} from "@mantine/core";
import { Calendar } from "@mantine/dates";
import { forwardRef } from "react";

const PatientDashboard = () => {
  // Hooks
  const [value, setValue] = useState(null);

  // Doctors
  const data = [
    {
      image:
        "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
      label: "Dr. Max Rodríguez",
      value: "Dr. Max Rodríguez",
      description: "General Doctor",
    },

    {
      image:
        "https://images.unsplash.com/photo-1594824476967-48c8b964273f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      label: "Dr. Carol Miller",
      value: "Dr. Carol Miller",
      description: "Cardiologist",
    },
    {
      image:
        "https://images.unsplash.com/photo-1537368910025-700350fe46c7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
      label: "Dr. Francesco Jamson",
      value: "Dr. Francesco Jamson",
      description: "Neurosurgeon",
    },
    {
      image:
        "https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80",
      label: "Dr. Quintana Kerin",
      value: "Dr. Quintana Kerin",
      description: "Orthopedic Surgeon",
    },
  ];

  // !important: Forwarding ref is required
  const SelectItem = forwardRef(
    ({ image, label, description, ...others }, ref) => (
      <div ref={ref} {...others}>
        <Group noWrap>
          <Avatar src={image} />

          <div>
            <Text>{label}</Text>
            <Text size="xs" color="dimmed">
              {description}
            </Text>
          </div>
        </Group>
      </div>
    )
  );

  return (
    <div className="Home" style={{ padding: "100px 8vw 15px 8vw" }}>
      <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Card shadow="sm" padding="lg" style={{ width: "32%" }}>
            <h2 style={{ marginBottom: 5 }}> Upcoming Appointments </h2>
            <Timeline
              active={1}
              bulletSize={24}
              lineWidth={2}
              color="green"
              style={{ marginTop: 20 }}
              reverseActive
            >
              <Timeline.Item title="General Checkup" lineVariant="dashed">
                <Text color="dimmed" size="sm">
                  You have an appointment with{" "}
                  <Text variant="link" component="span" inherit>
                    Dr Sam
                  </Text>
                </Text>
                <Text size="xs" style={{ marginTop: 4 }}>
                  in 2 days
                </Text>
                <div style={{ display: "flex" }}>
                  <Button
                    color="gray"
                    size="xs"
                    compact
                    style={{ marginTop: 4 }}
                  >
                    Reschedule
                  </Button>
                  <Button
                    color="red"
                    variant="light"
                    size="xs"
                    compact
                    style={{ marginTop: 4, marginLeft: 4 }}
                  >
                    <AiOutlineDelete size={14} />
                  </Button>
                </div>
              </Timeline.Item>

              <Timeline.Item
                title="Blood Pressure Monitoring"
                lineVariant="dashed"
              >
                <Text color="dimmed" size="sm">
                  You have an appointment with{" "}
                  <Text variant="link" component="span" inherit>
                    Dr Robert
                  </Text>{" "}
                </Text>
                <Text size="xs" style={{ marginTop: 4 }}>
                  in 7 days
                </Text>
                <div style={{ display: "flex" }}>
                  <Button
                    color="gray"
                    size="xs"
                    compact
                    style={{ marginTop: 4 }}
                  >
                    Reschedule
                  </Button>
                  <Button
                    color="red"
                    variant="light"
                    size="xs"
                    compact
                    style={{ marginTop: 4, marginLeft: 4 }}
                  >
                    <AiOutlineDelete size={14} />
                  </Button>
                </div>
              </Timeline.Item>

              <Timeline.Item
                bullet={<GrFormCheckmark size={26} />}
                title="Vaccination Appointment"
                lineActive="true"
              >
                <Text color="dimmed" size="sm">
                  You had an appointment with{" "}
                  <Text variant="link" component="span" inherit>
                    Dr Sam
                  </Text>
                </Text>
                <Text size="xs" style={{ marginTop: 4 }}>
                  1 hour ago
                </Text>
              </Timeline.Item>

              <Timeline.Item
                bullet={<GrFormCheckmark size={26} />}
                title="Dental Checkup"
              >
                <Text color="dimmed" size="sm">
                  You had an appointment{" "}
                  <Text variant="link" component="span" inherit>
                    Dr Tom
                  </Text>
                </Text>
                <Text size="xs" style={{ marginTop: 4 }}>
                  2 days ago
                </Text>
              </Timeline.Item>
            </Timeline>
          </Card>

          <Card shadow="sm" padding="lg" style={{ width: "65%" }}>
            <h2 style={{ marginBottom: 5 }}>Book an Appointment</h2>
            <Select
              style={{ width: 300, marginBottom: 20 }}
              label="Choose Doctor"
              placeholder="Pick one"
              itemComponent={SelectItem}
              data={data}
              searchable
              maxDropdownHeight={400}
              nothingFound="Nobody here"
              filter={(value, item) =>
                item.label.toLowerCase().includes(value.toLowerCase().trim()) ||
                item.description
                  .toLowerCase()
                  .includes(value.toLowerCase().trim())
              }
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <Calendar
                style={{
                  marginLeft: 15,
                  boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
                  borderRadius: 3,
                }}
                value={value}
                onChange={setValue}
              />
              <div style={{ marginLeft: 40 }}>
                <Chips
                  spacing="xl"
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <Chip value="1">08:00 - 08:30</Chip>
                  <Chip value="2">08:30 - 09:00</Chip>
                  <Chip value="3">09:00 - 09:30</Chip>
                  <Chip value="4">09:30 - 10:00</Chip>
                  <Chip value="5">10:00 - 10:30</Chip>
                  <Chip value="6">10:30 - 11:00</Chip>
                  <Chip value="7">11:00 - 11:30</Chip>
                  <Chip value="8">11:30 - 12:00</Chip>
                  <Chip value="9">13:00 - 13:30</Chip>
                  <Chip value="10">13:30 - 14:00</Chip>
                  <Chip value="11">14:00 - 14:30</Chip>
                  <Chip value="12">14:30 - 15:00</Chip>
                  <Chip value="13">15:00 - 15:30</Chip>
                  <Chip value="14">15:30 - 16:00</Chip>
                  <Chip value="15">16:00 - 16:30</Chip>
                  <Chip value="16">16:30 - 17:00</Chip>
                  {/* <Chip value="17">17:00 - 17:30</Chip>
                  <Chip value="18">17:30 - 18:00</Chip>
                  <Chip value="19">18:00 - 18:30</Chip>
                  <Chip value="20">18:30 - 19:00</Chip> */}
                </Chips>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="filled"
                size="md"
                color="indigo"
                leftIcon={<RiAddBoxFill />}
                style={{ marginTop: 10 }}
              >
                Submit
              </Button>
            </div>
          </Card>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Card
            shadow="sm"
            padding="lg"
            style={{ marginTop: 40, width: "65%" }}
            className="container"
          >
            <h2 style={{ marginBottom: 15 }}>
              Electronic Health Records (EHR)
            </h2>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 15,
              }}
            >
              <Paper
                padding="sm"
                shadow="xs"
                withBorder
                style={{
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h3>Abdominal Pain</h3>
                  <Text color="dimmed">#4356254378</Text>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Text size="sm">Created on</Text>
                  <Text color="dimmed">20/02/2022</Text>
                </div>
              </Paper>
              <Paper
                padding="sm"
                shadow="xs"
                withBorder
                style={{
                  width: "25%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Text style={{ display: "flex", alignItems: "center" }}>
                  More Info <AiOutlineArrowRight style={{ marginLeft: 5 }} />
                </Text>
              </Paper>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 15,
              }}
            >
              <Paper
                padding="sm"
                shadow="xs"
                withBorder
                style={{
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h3>Eczema</h3>
                  <Text color="dimmed">#3623893547</Text>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Text size="sm">Created on</Text>
                  <Text color="dimmed">18/01/2022</Text>
                </div>
              </Paper>
              <Paper
                padding="sm"
                shadow="xs"
                withBorder
                style={{
                  width: "25%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Text style={{ display: "flex", alignItems: "center" }}>
                  More Info <AiOutlineArrowRight style={{ marginLeft: 5 }} />
                </Text>
              </Paper>
            </div>
          </Card>

          <Card
            shadow="sm"
            padding="lg"
            style={{ marginTop: 40, width: "32%" }}
          >
            <h2 style={{ marginBottom: 15 }}>Medications</h2>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <RiAddBoxFill
                    style={{ background: "green", color: "white" }}
                    size={40}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 10,
                  }}
                >
                  <Text style={{}}>Camylofin</Text>
                  <Text color="dimmed">1000mg, 20 Pills</Text>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <Text color="dimmed">Neareast Pharmacy</Text>
                <Text>Shoppers Drug Mart</Text>
              </div>
            </div>

            <Divider style={{ margin: 15 }} />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <RiAddBoxFill
                    style={{ background: "green", color: "white" }}
                    size={40}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 10,
                  }}
                >
                  <Text style={{}}>Dexlansoprazole</Text>
                  <Text color="dimmed">40mg, 5 Pills</Text>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <Text color="dimmed">Neareast Pharmacy</Text>
                <Text>Sobeys Pharmacy Merrymeeting</Text>
              </div>
            </div>

            <Divider style={{ margin: 15 }} />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <RiAddBoxFill
                    style={{ background: "green", color: "white" }}
                    size={40}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 10,
                  }}
                >
                  <Text style={{}}>Famotidine</Text>
                  <Text color="dimmed">100mg, 10 Pills</Text>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <Text color="dimmed">Neareast Pharmacy</Text>
                <Text>The Prescription Shoppe</Text>
              </div>
            </div>

            <Divider style={{ margin: 15 }} />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <RiAddBoxFill
                    style={{ background: "green", color: "white" }}
                    size={40}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 10,
                  }}
                >
                  <Text style={{}}>Mepenzolate</Text>
                  <Text color="dimmed">3000mg, 30 Pills</Text>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <Text color="dimmed">Neareast Pharmacy</Text>
                <Text>Lawtows Drugs</Text>
              </div>
            </div>
          </Card>
        </div>

        <iframe
          style={{ marginTop: 40 }}
          id="embeddedHuman"
          frameBorder="0"
          width="100%"
          height="600"
          allowFullScreen={true}
          src="https://human.biodigital.com/widget/?m=production/maleAdult/male_complete_anatomy_15_high_def.json&amp;ui-tools=true&amp;ui-panel=true&amp;uaid=f7n"
        ></iframe>
      </div>
    </div>
  );
};

export default PatientDashboard;
